var e={name:"widget-messenger-ornament",methods:{getStyles:function(){return{opacity:Math.random()+.1}}}};export{e as default};
